const normalizeBaseUrl = (url) => {
  if (!url) return '';
  return String(url).trim().replace(/\/+$/, '');
};

/** Active build profile: dev | uat | prod (from environment/environment_*). */
export const getAppEnv = () => process.env.REACT_APP_ENV || 'dev';

/** API base URL — set per profile in environment/environment_<profile>. */
export const getBaseUrl = () => {
  const raw =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_BASE ||
    'https://dev.settleai.app/api';
  return normalizeBaseUrl(raw);
};

/** WebSocket base URL derived from env or API base URL. */
export const getWsUrl = () => {
  const envWs = process.env.REACT_APP_WS_BASE || process.env.REACT_APP_WS_BASE_URL;
  if (envWs) {
    const normalized = envWs.trim().replace(/\/+$/, '');
    if (normalized.endsWith('/ws')) {
      return normalized;
    }
    return `${normalized}/ws`;
  }
  const raw = getBaseUrl();
  if (!raw) return '';
  const ws = raw.replace(/^http/, 'ws');
  if (ws.endsWith('/api')) {
    return `${ws}/ws`;
  }
  return `${ws}/api/ws`;
};

